import React from 'react';
import Layout from 'layout/Layout';
import NotFound from 'components/NotFound';

const Error500Page: React.FC = () => {
  const pageTitle = 'web予約';

  return (
    <Layout pageTitle={pageTitle}>
      <NotFound
        message={
          '現在、サービスを利用することができません。しばらく時間をおいてから再度お試しください。'
        }
      ></NotFound>
    </Layout>
  );
};
export default Error500Page;
